import { STATUS_TYPE } from "taltech-styleguide";
import { ErrorScreenProps , ErrorScreen} from "./ErrorScreen";

export const Error500Screen: React.FC<any> = (as:any) => {
  const props: ErrorScreenProps = {
    variant: STATUS_TYPE.DANGER,
    status: 500,
    title: "Internal server error",
    message: "An unexpected error has occurred",
  };
  return <ErrorScreen {...props} />;
};
